import type { AppShellProps } from "./types";
import styles from "./AppShell.module.scss";
import { cn } from "@/lib/cn";

export function AppShell({
  topBar,
  sidebar,
  children,
  className,
  ...rest
}: AppShellProps) {
  return (
    <div className={cn(styles.root, className)} {...rest}>
      {topBar}
      <div className={styles.body}>
        {sidebar}
        <div className={styles.main}>{children}</div>
      </div>
    </div>
  );
}
